<template>
    <section>
        <div v-if="showHeaterFooter == true" class="header-wrap bg-white border-bottom sticky-top">
            <!-- Inicio de la barra de navegacion -->
            <nav class="container-fluid max-w-1350 py-3 px-2 d-flex justify-content-between">
                <a href="/landing" class="standard-logo img-fluid">
                    <img src="/build/images/img_fe_v2m/logo-v2m.svg" class="img-fluid"  alt="Video2Market" width="200">
                </a>
                <div>
                    <a href="/landing" class="back-btn">{{ translate('label.back') }}</a>
                </div>
            </nav>
            <!-- Fin de la barra de navegacion -->
        </div>
        <div v-if="resultMessage.type != 'warning-keyword'" class="container-collections-campaigns">
            <section v-if="showHeaterFooter == true" class="portfolio-container">
                <div class="container-fluid max-w-1350">
                    <div class="portfolio-back">
                        <div class="text-uppercase mb-0 portfolio-title d-inline-block">
                            {{ translate('label.portfolio') }}
                        </div>
                    </div>
                </div>
            </section>
            <campaign-list v-if="isFetching == false" :is-fetching="isFetching" :limit-to-show="12"></campaign-list>
        </div>
    </section>
</template>

<script setup>
import { ref, computed, onMounted, inject } from 'vue';
import CampaignList from "@/portfolio/components/campaignList.vue";
import { getCampaigns } from "@/portfolio/services/videos-service";
import { useTranslation } from "@/composables/useTranslation"
import { usePortfolioStore } from "../storage/storePortfolio";

const { translate } = useTranslation();
const portfolioStore = usePortfolioStore();


const showHeaterFooter = ref(true);

const isFetching = computed(() => portfolioStore.getIsFetching);
const resultMessage = computed(() => portfolioStore.getResultMessage);

onMounted(async () => {
    portfolioStore.setIsFetching(true);
    portfolioStore.cleanCampaigns();

    const dataResult1 = await getCampaigns(false, 1);
    if (dataResult1) {
        portfolioStore.addCampaignsByPage({campaigns: dataResult1.campaigns, page: dataResult1.page});
        portfolioStore.setResultMessage(dataResult1.resultMessage);
        portfolioStore.setSiteUrl(dataResult1.siteUrl);
    }
    const dataResult2 = await getCampaigns(true);
    if (dataResult2) {
        portfolioStore.setTotalCampaignsGeneral(parseInt(dataResult2));
        portfolioStore.setIsFetching(false);
    }

    showHeaterFooter.value = parseInt($('#showHeaterFooter').val());

    $('#loader-container').hide();
});
</script>
